import * as React from "react"

const SvgIcon = props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 250">
    <defs>
      <linearGradient
        id="award-badge-gradient"
        x1="23.83"
        x2="226.17"
        y1="269.49"
        y2="-19.49"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.27" stopColor="#fff"></stop>
        <stop offset="0.46"></stop>
      </linearGradient>
      <mask
        id="award-badge-mask"
        width="253.76"
        height="252.98"
        x="-1.88"
        y="-1.49"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="url(#award-badge-gradient)"
          d="M-1.88-1.49h253.76v252.98H-1.88z"
        ></path>
      </mask>
    </defs>
    <g mask="url(#award-badge-mask)">
      <path
        fill="#c59c0b"
        d="M125 0C55.96 0 0 55.96 0 125s55.96 125 125 125 125-55.96 125-125S194.04 0 125 0m0 218.55c-51.67 0-93.55-41.88-93.55-93.55S73.33 31.45 125 31.45s93.55 41.88 93.55 93.55-41.88 93.55-93.55 93.55"
      ></path>
      <path
        fill="#fff"
        d="m142.88 226.98 3.85-.74c.28-.05.56-.04.86.04.29.08.57.22.82.42q.375.3.66.75c.19.3.31.64.39 1.03.07.37.08.73.04 1.07-.05.34-.14.65-.28.93-.14.27-.32.5-.55.69q-.345.285-.78.36l-3.99.76-1.02-5.3Zm2.6 13.58-1.05-5.49 3.14-.6 4.39 4.85 3.57-.68-4.91-5.44c.83-.56 1.43-1.32 1.8-2.29.36-.97.44-1.99.24-3.05a5.4 5.4 0 0 0-.77-1.9c-.39-.6-.86-1.12-1.42-1.54q-.84-.645-1.89-.93c-.7-.19-1.42-.22-2.18-.07l-7.24 1.39 3.14 16.37 3.18-.61Zm-15.51-1.15-.27-4.33 7-.44-.17-2.62-7.01.44-.25-4.01 8.11-.51-.18-2.84-11.34.72 1.05 16.64 11.55-.73-.18-2.83-8.32.53Zm-10.35 2.91 2.62.23 1.47-16.58-3.23-.29-.97 10.87-7.68-11.66-2.5-.22-1.48 16.6 3.23.29.94-10.64 7.59 11.4Zm-18.92-2.45 2.55.62 3.95-16.17-3.15-.77-2.59 10.6-5.85-12.69-2.44-.6-3.95 16.19 3.15.77 2.53-10.38 5.79 12.41Zm-15.81-4.56 5.92-15.58-3.03-1.15-5.92 15.58zM70.82 218.8l-4.4 3.64 2.18-13.63-3.03-1.7-2.25 17.84 2.38 1.33 5.93-4.7-.89 7.52 2.38 1.33 14.06-11.24-3.07-1.72-10.44 9.01.76-5.68 6.18-5.23-2.62-1.47-4.33 3.9 1.05-5.73-2.6-1.46-1.26 7.98Zm-18.65-9.74q-.93.51-1.89.63c-.64.08-1.28 0-1.93-.2-.64-.22-1.26-.59-1.84-1.14l-2.06-1.92 7.49-8.04 2.06 1.92c.57.53.99 1.11 1.27 1.72.27.62.4 1.25.38 1.89s-.18 1.28-.48 1.93c-.3.64-.72 1.26-1.26 1.84-.53.57-1.11 1.03-1.73 1.37m-7.61 1.37c.92.85 1.88 1.48 2.89 1.87 1.01.4 2.03.57 3.05.53s2.02-.31 3-.8q1.47-.735 2.76-2.13c.78-.84 1.39-1.74 1.82-2.71.44-.97.66-1.97.67-2.99 0-1.02-.21-2.04-.67-3.06-.45-1.02-1.18-1.99-2.17-2.92l-4.43-4.13-11.36 12.2 4.43 4.13Zm-2.32-23.15 2.46 3.05c.18.22.3.48.37.77.07.3.07.6.02.92-.06.32-.17.63-.35.93s-.42.58-.72.82c-.29.24-.6.41-.93.53-.32.12-.64.19-.95.19s-.6-.05-.87-.16-.5-.28-.69-.52l-2.55-3.16 4.2-3.39Zm-10.77 8.67 4.35-3.5 2 2.49-2.22 6.15 2.28 2.83 2.5-6.89c.88.47 1.84.64 2.87.51s1.96-.54 2.8-1.22c.52-.42.96-.95 1.31-1.57s.58-1.28.7-1.98c.11-.69.09-1.39-.07-2.1a4.8 4.8 0 0 0-.96-1.96l-4.62-5.74-12.98 10.46 2.03 2.52Zm-3.33-16.81 6.86-1.27-4.47 5.31zm-8.28-1.38 1.7 2.87 4.35-.8 2.96 5.01-2.79 3.45 1.7 2.87 11.12-13.94-1.46-2.46-17.58 3.01Zm3.06-16.41-5.72-.04 10.43-9.04-1.24-3.25-13.19 12.22.97 2.55 7.57.21-5.51 5.19.97 2.54 17.99.42-1.25-3.29-13.79.19 4.23-3.87 8.1-.04-1.07-2.81-5.82.2 4.49-3.72-1.06-2.79-6.1 5.31Zm-7.26-17.54 6.88 1.12-6 3.49zm-7.34-4.1.63 3.27 4.37.72 1.1 5.72-3.79 2.3.63 3.27 15.18-9.36-.54-2.81-17.57-3.11Z"
      ></path>
    </g>
  </svg>
)

export default SvgIcon
